import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import Question  from '../types/question';
import './flashcard.css'; // Import the CSS file for styling

interface FlashcardProps {
  question: Question | null;
}

const Flashcard: React.FC<FlashcardProps> = ({ question }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState<Question | null>(null);

  const handleCardClick = () => {
    if (question) {
      setIsFlipped(!isFlipped);
    }
  };

  // face of card after changing
  useEffect(() => {
    if (question) {
      setIsFlipped(false);
      const timer = setTimeout(() => {
        setCurrentQuestion(question);
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [question]);

  return (
    <Box textAlign="center"  sx={{ m: 2 }}>
    <Card onClick={handleCardClick} className={`flashcard ${isFlipped ? 'flipped' : ''}`}>
      <CardContent className="flashcard-content">
        {currentQuestion ? (
          <>
            <div className="front">
              <Typography variant="body1" component="div">
                Question #{currentQuestion.number}
              </Typography>
              <Typography variant="h5" color="text.primary">
                {currentQuestion.question}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Chapter: {currentQuestion.chapter}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Session: {currentQuestion.session}
              </Typography>
            </div>
            <div className="back">
              <Typography variant="body2" color="text.secondary">
                {currentQuestion.answer}
              </Typography>
            </div>
          </>
        ) : (
          <Typography variant="body1" color="text.secondary">
            No question available, please press the button below to get a random question
          </Typography>
        )}
      </CardContent>
    </Card>
    </Box>
  );
};

export default Flashcard;